var map = {
	"./118970_Falkenberg_Energi_5_Tuffast-1.jpg": 9450,
	"./150611_Sundsvalls_kommun-1.jpg": 1863,
	"./20200211_Lidkoping.husguiden.feb-1.jpg": 5936,
	"./2663072_HP Rör_Värme_Bad_Värme-1.jpg": 6104,
	"./3277761_Elon Ljud_Bild_Falkenberg-1.jpg": 8910,
	"./3537869_XL_BYGG_Vårgårda-1.jpg": 6386,
	"./3553095_Optimalfönster-1.jpg": 9096,
	"./56779_Colorama_Tappers-1.jpg": 4724,
	"./635679_Siljansnäs_Eltjänst_Elon_Leksand-1.jpg": 4146,
	"./701908_Sandberg-1.jpg": 9491,
	"./98586_Svenssons-1.jpg": 1628,
	"./OLD_optimera.png": 9759,
	"./OLD_optimera_lg.png": 8210,
	"./Reaxcer_Berg-1.jpg": 3506,
	"./bergvarme_solleftea.png": 6398,
	"./bergvarme_solleftea_lg.png": 4336,
	"./borjesskogs.jpg": 9055,
	"./edbergs_bygg.png": 7185,
	"./edbergs_bygg_lg.png": 8593,
	"./eldabutiken.png": 305,
	"./eldabutiken_lg.png": 6385,
	"./falkenberg_energi.png": 8069,
	"./farg1an.png": 197,
	"./farg1an_lg.png": 165,
	"./harmangers_plat.png": 9237,
	"./harmangers_plat_lg.png": 4229,
	"./kraftringen.png": 3050,
	"./kraftringen_lg.png": 9532,
	"./lefflers.png": 9854,
	"./lefflers_lg.png": 7792,
	"./optimera.png": 3798,
	"./optimera_lg.png": 9496,
	"./pireva.png": 4334,
	"./pireva_lg.png": 5792,
	"./reaxcer.png": 1917,
	"./reaxcer_lg.png": 5085,
	"./sandberg.png": 6651,
	"./sandberg_lg.png": 775,
	"./small/carlsson.png": 4276,
	"./small/elbutiken.png": 4730,
	"./small/hj.png": 4910,
	"./small/mio.png": 3406,
	"./small/nk.png": 2082,
	"./small/svensson.png": 6720,
	"./small/wttech.png": 1402,
	"./sydpumpen.png": 1428,
	"./sydpumpen_lg.png": 7834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5011;